/**
 * Formats numbers based on Intl.NumberFormat.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param {number | null | undefined} value - The numeric value to format.
 * @param {boolean} [short=false] - Whether to use compact notation (e.g., 1.2K).
 * @param {string} [locale='en-US'] - Locale string (e.g., 'en-US', 'uk-UA').
 *
 * @returns {string} Formatted number or an empty string/zero if value is invalid.
 */
export default function formatNumber(
    value: number | null | undefined,
    short: boolean = false,
    locale: string = 'en-US',
): string {
    if (value === null || value === undefined || isNaN(value)) return '0';

    let options: Intl.NumberFormatOptions = {
        maximumFractionDigits: 0,
    };

    if (short) {
        options = {
            notation:              'compact',
            compactDisplay:        'short',
            maximumFractionDigits: value > 10000 ? 0 : 2,
        };
    }

    return new Intl.NumberFormat(locale, options).format(value);
}
